import { render } from "./v-input.vue?vue&type=template&id=53512a03"
import script from "./v-input.vue?vue&type=script&lang=js"
export * from "./v-input.vue?vue&type=script&lang=js"

import "./v-input.vue?vue&type=style&index=0&id=53512a03&lang=scss"
import "./v-input.vue?vue&type=style&index=1&id=53512a03&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/v-input.vue'],['render',render],['__file',"v-input.vue"]])

export default __exports__